import { makeAutoObservable } from 'mobx'
import { openApi } from '../../../../helpers/request'
import { GatewaySplitRow } from '../../../../components/GatewaySplitEditor'

class ProductSplitPaymentsController {

  rows: GatewaySplitRow[] = []
  render: boolean = false
  productId: number | null = null

  constructor() {
    makeAutoObservable(this)
  }

  get(productId: number) {
    this.productId = productId
    this.render = false

    return openApi('get', `/product_payment_split/${productId}`)
      .then((result: any) => {
        this.rows = result.data ?? []
        this.render = true
      })
      .catch(error => console.log(error.response))
  }

  setRows(rows: GatewaySplitRow[]) {
    this.rows = rows
  }

  save() {
    if(!this.productId)
      return Promise.resolve()

    const data = new FormData()
    data.append('rows', JSON.stringify(this.rows))

    return openApi('post', `/product_payment_split/${this.productId}`, data)
  }
}

export default new ProductSplitPaymentsController()
